import {allOkrURL, oneOkrURL} from "../../services/api";
import api from '../../services/instanceapi'
import {
    DELETE_OBJECTIVE,
    FETCH_OBJECTIVE,
    FETCH_OBJECTIVE_FAIL,
    FETCH_OBJECTIVES,
    FETCH_OBJECTIVES_FAIL, LOADING_OBJECTIVES, PATCH_ONE_OBJECTIVE, PATCH_ONE_OBJECTIVE_FAIL,
    POST_ONE_OBJECTIVE,
    POST_ONE_OBJECTIVE_FAIL
} from "./actionTypes";
import {checkErrorMessage} from "../../utils/utils";
import {DELETE_PROJECT_FAIL} from "../project/actionsType";


export const postObjective = (data) => async (dispatch) => {
    try {
        const okr = await api.post(allOkrURL(), data);
        dispatch({
            type: POST_ONE_OBJECTIVE,
            payload: {
                status: okr.status,
                message: okr.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_ONE_OBJECTIVE_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}

export const patchObjective = (id, data) => async (dispatch) => {
    try {
        const okr = await api.patch(oneOkrURL(id), data);
        dispatch({
            type: PATCH_ONE_OBJECTIVE,
            payload: {
                status: okr.status,
                message: okr.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_ONE_OBJECTIVE_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}

export const loadOneObjective = (okr_id) => async (dispatch) => {
    try {
        const okr = await api.get(oneOkrURL(okr_id))
        dispatch({
            type: FETCH_OBJECTIVE,
            payload: {
                id: okr.data.id,
                comment: okr.data.comment,
                title: okr.data.title,
                weather: okr.data.weather,
                pilot: okr.data.pilot,
                endDate: okr.data.endDate,
                tags: okr.data.tags,
                lastUpdate: okr.data.lastUpdate,
                keyResults: okr.data.keyResults,
                linkedProjects: okr.data.linkedProjects,
                availableTags:okr.data.availableTags,
                onGoing: okr.data.onGoing,
                deleted: okr.data.deleted,
                status: okr.status,
                message: okr.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_OBJECTIVE_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}


export const loadAllObjectives = () => async (dispatch) => {
    dispatch({
        type: LOADING_OBJECTIVES,
    });
    try {
        const {data} = await api.get(allOkrURL());
        dispatch({
            type: FETCH_OBJECTIVES,
            payload: {
                okrs: data,
                status: 200,
                message: "OK"
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_OBJECTIVES_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}

export const deleteObjective = (id) => async (dispatch) => {
    try {
        const deletedOKR = await api.delete(oneOkrURL(id));
        dispatch({
            type: DELETE_OBJECTIVE,
            payload: {
                status: deletedOKR.status,
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_PROJECT_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
    }
}
